import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  jump(event) {
    const select = event.currentTarget
    const url = new URL(window.location)

    if (select.dataset.hostonly) {
      window.location = select.value
      return
    }

    const [param, value] = select.value.split("=")
    url.searchParams.set(param, value)
    window.location = url
  }
}
